import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from './auth.service';
import { handleThunkError } from '../helpers/thunkError';

// --- AuthCallback workflow: only send callback params ---
export const sendCallbackParams = createAsyncThunk(
  'auth/sendCallbackParams',
  async (_, thunkAPI) => {
    try {
      await authService.sendCallbackParams();
      return true;
    } catch (error) {
      return handleThunkError(error, thunkAPI, 'Failed at send call back params');
    }
  }
);

// --- Restore session workflow ---
export const getSession = createAsyncThunk('auth/getSession', async (_, thunkAPI) => {
  try {
    const data = await authService.getSession();
    return data;
  } catch (error) {
    return handleThunkError(error, thunkAPI, 'Failed to get session');
  }
});

// --- Logout ---
export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    const endSessionUrl = await authService.logout();
    return endSessionUrl;
  } catch (error) {
    return handleThunkError(error, thunkAPI, 'Failed to logout');
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    claims: null,
    isAuthenticated: false,
    loading: false,
    loggingOut: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // --- Send Callback Params workflow ---
      .addCase(sendCallbackParams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendCallbackParams.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendCallbackParams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Callback failed';
      })
      // --- Logout workflow ---
      .addCase(logout.pending, (state) => {
        state.loggingOut = true;
        state.isAuthenticated = false;
        state.user = null;

        state.claims = null;
      })
      .addCase(logout.rejected, (state) => {
        state.loggingOut = false;
      })
      // --- Restore session workflow ---
      .addCase(getSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSession.fulfilled, (state, action) => {
        const payload = action.payload;

        state.loading = false;
        state.user = payload.user;
        state.claims = payload.claims;
        state.isAuthenticated = payload.authenticated === true;
      })
      .addCase(getSession.rejected, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
        state.claims = null;
      });
  }
});

export default authSlice.reducer;
